import React from 'react';
import PropTypes from 'prop-types';
import styles from './ConfirmDeleteModal.module.scss';
import Button from '../../common/Button';
import ModalWindow from '../../common/Modal';
import { isArray } from 'lodash';

function ConfirmModal(props) {
  const { onCancel, open = false } = props;
  let text = props.text || '';

  if (isArray(props.text)) {
    text = props.text.map((text, index) => <span key={`${text}-${index}`}>{text}</span>);
  }

  const handleConfirm = () => {
    const { onConfirm, objectId } = props;
    if (objectId) {
      onConfirm(objectId);
    } else {
      onConfirm();
    }
  };

  return (
    <ModalWindow open={open} onClose={onCancel}>
      <div className={styles.body}>
        <p>{text}</p>

        <div className={styles.buttons}>
          <Button text={props.confirmButton || 'Ok'} margin onClick={handleConfirm} />
          <Button text={props.cancelButton || 'Cancel'} color="white" margin onClick={onCancel} />
        </div>
      </div>
    </ModalWindow>
  );
}

export default ConfirmModal;

ConfirmModal.propTypes = {
  open: PropTypes.bool,
  text: PropTypes.node,
  objectId: PropTypes.number,
  onConfirm: PropTypes.func,
  onCancel: PropTypes.func.isRequired,
};
